import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";

// Actions
import {
  setView,
  fetchProtocolsList,
  fetchLocalStudiesList,
  setTemplatePrompt,
  fetchLocalParticipantsList,
  fetchLocalParticipantLog,
  fetchCustomProtocolTemplate,
} from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
// Other Files
import { customTheme } from "../../constants/customTheme";
import { viewIds } from "../../constants/componentMap";
import Header from "./../Header/Header";
import SnackbarInfo from "./../Shared/Snackbar";

const useStyles = makeStyles({
  fill: {
    flex: "1 0 auto",
  },
  cardRoot: (props) => ({
    ...customTheme(props.theme).card.root,
    "@media only screen and (max-width: 900px)": {
      width: "90%",
    },
    width: "75%",
  }),
  title: customTheme().card.title,
  buttonContainer: {
    ...customTheme().card.buttonContainer,
    padding: "0px",
  },
  buttonInd: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: "5px",
  },
  button: (props) => customTheme(props.theme).buttonPrimary,
  description: {
    alignSelf: "center",
    textAlign: "center",
    fontSize: "0.875rem",
  },
  copyright: customTheme().copyright,
});

function StartPage(props) {
  const classes = useStyles(props);

  const handleNewStudy = () => {
    props.setView(viewIds.newStudy);
    // props.fetchProtocolsList();
    // props.fetchLocalParticipantLog();
  };

  const handleLoadParticipantReview = () => {
    // props.fetchLocalParticipantsList();
    props.setView(viewIds.loadParticipantReview);
  };

  const handleLoadStudy = (prompt) => {
    // props.fetchLocalStudiesList();
    props.setTemplatePrompt(prompt === "TEMPLATE");
    props.setView(viewIds.loadStudy);
  };

  const handleCreateProtocol = () => {
    props.fetchCustomProtocolTemplate(); // need all avaialble protocols to ensure the new protocol does not have the same protocol ID as an exisitng protocol
  };

  return (
    <Grid
      item
      container
      className={classNames(classes.fill, "noselect")}
      direction="column"
    >
      {/* HEADER */}
      <Header
      //  eventSource={props.eventSource}
      />

      <Grid
        item
        container
        className={classes.fill}
        direction="column"
        justify="space-between"
      >
        <Typography style={{ alignSelf: "center", marginTop: "10px" }}>
          This is a limited demo of MicroElastic's user interface. The demo
          includes device simulation and fixture data.
        </Typography>
        <Grid
          item
          container
          className={classes.fill}
          direction="column"
          justify="center"
          alignItems="center"
        >
          {/* INFORMATION CARD */}
          <Card className={classes.cardRoot}>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              className={classes.title}
            >
              What Would You Like to Do?
            </Typography>

            <div className={classes.buttonContainer}>
              <div className={classes.buttonInd}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleNewStudy()}
                >
                  NEW STUDY
                </Button>
                <Typography className={classes.description}>
                  Start a new study.
                </Typography>
              </div>
              <div className={classes.buttonInd}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  // disabled={true}
                  className={classes.button}
                  onClick={() => handleCreateProtocol()}
                >
                  PROTOCOL
                </Button>
                <Typography className={classes.description}>
                  Create a new custom protocol.
                </Typography>
              </div>
              <div className={classes.buttonInd}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleLoadStudy("DATA")}
                >
                  LOAD STUDY
                </Button>
                <Typography className={classes.description}>
                  Load a saved study to view results or continue where you left
                  off.
                </Typography>
              </div>
              <div className={classes.buttonInd}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleLoadStudy("TEMPLATE")}
                >
                  FOLLOW-UP
                </Button>
                <Typography className={classes.description}>
                  Load a saved study without data to use as the protocol for a
                  new study.
                </Typography>
              </div>
              <div className={classes.buttonInd}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleLoadParticipantReview()}
                >
                  REVIEW
                </Button>
                <Typography className={classes.description}>
                  Review a participant's data over multiple studies.
                </Typography>
              </div>
            </div>
          </Card>
        </Grid>

        {/* COPYRIGHT INFO */}
        <Grid item align="center" className={classes.copyright}>
          <Typography variant="caption" gutterBottom>
            This software is for investigational research use only. It is
            provided as-is with no warranty. &copy;{new Date().getFullYear()}{" "}
            MicroElastic Ultrasound Systems
          </Typography>
        </Grid>
      </Grid>

      {/* SNACKBAR FOR MESSAGE DISPLAY */}
      <SnackbarInfo />
    </Grid>
  );
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setView,
      fetchProtocolsList,
      fetchLocalParticipantsList,
      fetchLocalParticipantLog,
      fetchLocalStudiesList,
      setTemplatePrompt,
      fetchCustomProtocolTemplate,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartPage);
